<template>
  <bulk-edit-games
    :is-loading="isLoading"
    :project-list="projectList"
    :update-difference="updateDiff"
    @bulk-update="onUpdate"
  />
</template>

<script>
import { API } from '@/utils/api'
import BulkEditGames from '../components/BulkEditGames.vue'
import { difference, map, concat } from 'lodash'

export default {
  components: {
    BulkEditGames,
  },

  data() {
    return {
      isLoading: false,
      updateDiff: [],
    }
  },

  computed: {
    projectList: function () {
      return concat(this.$store.state.auth.user.settings.base ? [] : [ { text: 'Default', value: null } ], map(this.$store.state.auth.entities, (i) => ({ text: i.name, value: i.entity_id })))
    },
  },

  methods: {
    onUpdate(args) {
      this.isLoading = true
      this.updateDiff = []

      return API.call('/$v/game/toggle_flags.json', args).then(r => {
        this.updateDiff = difference(args.games, r.data.map(game => game.game_id))

        const resultMsg = `Successfully updated ${r.data.length} games out of ${args.games.length}`
        this.$showSuccess(resultMsg)
      }).finally(() => {
        this.isLoading = false
      })
    }
  }
}
</script>
